@if (isOwnComment()) {
  <div class="flex items-start gap-3">
    <div class="flex flex-col min-w-0 flex-1">
      <div class="flex items-baseline justify-end gap-2 mb-1">
        <span class="text-xs text-surface-400 leading-none">{{ comment().createdAt | date:'dd/MM/yy HH:mm' }}</span>
        <span class="text-sm font-semibold text-surface-800 leading-none">{{ 'app.me' | translate }}</span>
      </div>
      <div
        [innerHTML]="comment().content | mentionRenderer"
        class="text-sm text-surface-700 bg-primary-50 border border-gray-200 rounded-lg rounded-tr-none px-3 py-2 leading-relaxed break-words"
      ></div>
    </div>
  </div>
} @else {
  <div class="flex items-start gap-3">
    <div class="flex flex-col min-w-0 flex-1">
      <div class="flex items-baseline gap-2 mb-1">
        <span class="text-sm font-semibold text-surface-800 leading-none">{{ comment().createdByFullName }}</span>
        <span class="text-xs text-surface-400 leading-none">{{ comment().createdAt | date:'dd/MM/yy HH:mm' }}</span>
      </div>
      <div
        [innerHTML]="comment().content | mentionRenderer"
        class="text-sm text-surface-700  border border-gray-200 rounded-lg rounded-tl-none px-3 py-2 leading-relaxed break-words"
      ></div>
    </div>
  </div>
}
